import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

import {NouisliderComponent} from 'ng2-nouislider';
import {RecipeAttributeOptionViewModel, RecipeAttributeViewModel} from '../../../shared/viewModels/recipeAttribute.viewModel';
import {ProductsService} from '../../../shared/services/products.service';
import {Constants} from '../../../shared/config/constants.config';
import {RecipesComponent} from '../news/recipes.component';
import {forkJoin} from 'rxjs';
import {RecipeCategoryViewModel} from '../../../shared/viewModels/recipeCategory.viewModel';

@Component({
    selector: 'app-recipes-filter-modal',
    templateUrl: './recipes-filter.component.html',
    styleUrls: ['./recipes-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipesFilterModalComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    @ViewChild('slider') slider: NouisliderComponent;

    attributes: RecipeAttributeViewModel[];
    recipesComponent: RecipesComponent;
    recipeCategories: RecipeCategoryViewModel[];

    selectedOptions = {};
    selectedCategories = [];
    hasVideo = false;
    mealPrepFriendly = false;

    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly productsService: ProductsService,
    ) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {
        forkJoin(
            this.productsService.getRecipesAttributes(),
            this.productsService.getRecipeAllCategories(),
        ).subscribe(([attributes, categories]) => {
            this.attributes = attributes;
            this.recipeCategories = categories;
            this.changeDetectorRef.markForCheck();

        });
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    onFilter() {
        this.recipesComponent.selectedAttributeOptionIds = Object.values(this.selectedOptions);
        this.recipesComponent.selectedCategoryIds = this.selectedCategories;
        this.recipesComponent.hasVideo = this.hasVideo;
        this.recipesComponent.mealPrepFriendly = this.mealPrepFriendly;

        this.bsModalRef.hide();
        this.recipesComponent.reload();
    }

    markAttrOption(attr_id: number, option: RecipeAttributeOptionViewModel) {
        this.selectedOptions[attr_id] = option.id;
        this.changeDetectorRef.markForCheck();
    }

    markCategory(category: RecipeCategoryViewModel, eventTarget) {
        if (eventTarget.target.checked === true) {
            this.selectedCategories.push(category.id);
        } else {
            this.selectedCategories = this.selectedCategories.filter(opt => opt !== category.id);
        }

        this.changeDetectorRef.markForCheck();
    }

    changeHasVideo() {
        this.hasVideo = !this.hasVideo;
        this.changeDetectorRef.markForCheck();
    }

    changeMealPrepFriendly() {
        this.mealPrepFriendly = !this.mealPrepFriendly;
        this.changeDetectorRef.markForCheck();
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

}
